import React from "react";
import { useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import ComponentCard from "../../components/common/ComponentCard";
import Button from "../../components/ui/button/Button";
import VenueOutletsTable from "./VenueOutletsTable";

const VenueOutlets = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageMeta
        title="Venue Outlets | Hospitality Genie"
        description="Menus - Venue Outlets"
      />
      <div className="space-y-6">
        <ComponentCard title="Menus - Venue Outlets">
          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-3">Venue Outlets</div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <Button
                className="inline-flex items-center gap-2 rounded-lg bg-[#142900] px-4 py-3 text-sm font-medium hover:bg-[#3d5e42]"
                size="sm"
                onClick={() => navigate("/add-venue-outlet")}
              >
                Add New Venue Outlet
              </Button>
            </div>
          </div>

          <VenueOutletsTable />
        </ComponentCard>
      </div>
    </>
  );
};

export default VenueOutlets;
